var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-screen flex w-full bg-img"},[_c('div',{staticClass:"vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"},[_c('p',{staticClass:"sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse font-30"},[_vm._v("有効なメニュー・プランがございませんでした。")])])])
}]

export { render, staticRenderFns }